import routes from './routes';
import { SetRoutes } from 'components';

const MeetingTypesMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default MeetingTypesMainPage;
